import {Container, Grid, MenuItem, TableBody, TableHead, TextField} from "@mui/material";
import React, {useEffect, useState} from "react";
import {
    StyledButtonContainer, StyledButtonOrange,
    StyledTable,
    StyledTableBodyRow, StyledTableCell,
    StyledTableCellHeader,
    StyledTableHeadRow
} from "../../../styles/MyStyles";
import dayjs from "dayjs";
import {GetEnumValueName} from "../../../logic/EnumHelper";
import {
    GetCryptoAmountExecutedAsSting,
    GetCryptoAmountRequestedAsSting, GetExecutedPricesSting,
    GetRequestedPricesSting
} from "../../../logic/OrderVolumeHelper";
import {useNavigate} from "react-router-dom";
import {GetCookieInfo} from "../../../logic/CookieManager";
import {GetClientViewName} from "../../../logic/ClientNameHelper";
import {GetClients} from "../../../logic/DataProvider";

const ActiveOrdersPage = () => {
    const navigate = useNavigate();
    const [clients, setClients] = useState([]);
    const [orders, setOrders] = useState([]);
    const [selectedClient, setSelectedClient] = useState('');

    useEffect(() => {
        GetClients().then((clients) => setClients(clients));
        const fetchOrders = async () => {
            try {
                const tokenCookie = GetCookieInfo('nplt');
                const response = await fetch(`${process.env.REACT_APP_ORDERS_URL}/active`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                });
                if (response.ok) {
                    const data = await response.json();
                    setOrders(data.data);
                } else {
                    console.log('Fetch orders failed.');
                }
            } catch (error) {
                console.log('An error occurred:', error);
            }
        };
        fetchOrders();
    }, []);

    const editOrder = (contactId, orderId) => {
        navigate(`/contacts/clients/${contactId}/order/${orderId}`);
    }

    const getClientsMenuItems = () => {
        let items = [<MenuItem key="" value="">All</MenuItem>];
        if (clients) {
            clients.forEach((elem) => {
                items.push(
                    <MenuItem key={elem.id} value={elem.id}>
                        {GetClientViewName(elem)}
                    </MenuItem>
                );
            });
        }
        return items;
    };

    const handleClientFilter = (event) => {
        setSelectedClient(event.target.value);
    };

    const filteredOrders = orders ? orders.filter(
        (order) => (selectedClient === '' || order.contactId === parseInt(selectedClient))
    ) : [];

    const handleGoBack = () => {
        navigate('/');
    };

    return (
        <Container sx={{ margin: '0.2rem', minWidth: '99%' }}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                    <TextField
                        select
                        label="Client"
                        value={selectedClient}
                        onChange={handleClientFilter}
                        margin="normal"
                        size="small"
                        fullWidth
                    >
                        {getClientsMenuItems()}
                    </TextField>
                </Grid>
                <Grid item xs={12} md={9} sx={{ textAlign: 'right' }}>
                    <StyledButtonContainer>
                        <StyledButtonOrange variant="contained" onClick={handleGoBack} margin="normal">
                            Back to dashboard
                        </StyledButtonOrange>
                    </StyledButtonContainer>
                </Grid>
                <Grid item xs={12}>
                    <StyledTable>
                        <TableHead>
                            <StyledTableHeadRow>
                                <StyledTableCellHeader columncount={10}>Created Date</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Expiration Date</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Contact</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Action</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Type</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Status</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Crypto Amount Requested</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Requested Price</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Crypto Amount Executed</StyledTableCellHeader>
                                <StyledTableCellHeader columncount={10}>Executed Price</StyledTableCellHeader>
                            </StyledTableHeadRow>
                        </TableHead>
                        <TableBody>
                            {filteredOrders && filteredOrders.map((order) => (
                                <StyledTableBodyRow key={order.id} onClick={() => editOrder(order.contactId, order.id)}>
                                    <StyledTableCell>{dayjs(order.createdDate).toDate().toDateString()}</StyledTableCell>
                                    <StyledTableCell>{dayjs(order.expirationDate).toDate().toDateString()}</StyledTableCell>
                                    <StyledTableCell>{GetClientViewName(clients.find(e => e.id === order.contactId))}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('orderAction', order.action)}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('orderType', order.type)}</StyledTableCell>
                                    <StyledTableCell>{GetEnumValueName('orderStatus', order.status)}</StyledTableCell>
                                    <StyledTableCell>{GetCryptoAmountRequestedAsSting(order)}</StyledTableCell>
                                    <StyledTableCell>{GetRequestedPricesSting(order)}</StyledTableCell>
                                    <StyledTableCell>{GetCryptoAmountExecutedAsSting(order)}</StyledTableCell>
                                    <StyledTableCell>{GetExecutedPricesSting(order)}</StyledTableCell>
                                </StyledTableBodyRow>
                            ))}
                        </TableBody>
                    </StyledTable>
                </Grid>
            </Grid>
        </Container>
    );
};

export default ActiveOrdersPage;